import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

import { AnalyticsGearExpressPage } from '@pages/analytics';
import type { RouterContext } from '@shared/config/router-context';
import { canAccessAnalyticsGear } from '@shared/lib';
import { useAbility } from '@features/authorization';
import { useAuth } from '@features/auth';
import { Header } from '@widgets/header';

export const Route = createFileRoute('/$locale/_authenticated/analytics-gear')({
  beforeLoad: ({ context, params }) => {
    const { auth, ability } = context as RouterContext;

    if (auth.isLoading || !auth.isAuthenticated) {
      return;
    }

    if (!canAccessAnalyticsGear(ability)) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({
        to: '/$locale/unauthorized',
        params: { locale: params.locale },
      });
    }
  },
  component: AnalyticsGearRoute,
});

function AnalyticsGearRoute() {
  const { locale } = Route.useParams();
  const ability = useAbility();
  const auth = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (auth.isLoading || !auth.isAuthenticated) {
      return;
    }

    if (!canAccessAnalyticsGear(ability)) {
      void navigate({
        to: '/$locale/unauthorized',
        params: { locale },
        replace: true,
      });
    }
  }, [ability, auth.isAuthenticated, auth.isLoading, locale, navigate]);

  return (
    <div className="flex min-h-full flex-col pt-16 min-[992px]:pt-0">
      <Header locale={locale} className="min-[992px]:hidden" />

      <main className="min-w-0 p-6">
        <AnalyticsGearExpressPage />
      </main>
    </div>
  );
}
